const isDevelopment = () => {
  // React native
  // if (typeof __DEV__ !== 'undefined') {
  //   return __DEV__;
  // }

  return process.env.NODE_ENV === 'development';
};

export default isDevelopment;
